<template>
    <div class="fixed top-0 left-0 z-50 h-screen w-screen flex justify-center items-center"
         :class="hideBackground ? '' : 'bg-black bg-opacity-50'">
        <div :class="[
            size === 'sm' ? 'w-4/12':'',
            size === 'md' ? 'w-6/12':'',
            size === 'lg' ? 'w-8/12':'',
            size === 'xl' ? 'w-10/12 h-1/2':'',
        ]"
             class="overflow-auto rounded shadow bg-white p-8 sirit-modal-content">
            <slot name="modalContent"></slot>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
//import * as Routing from '@/router/Routing'

export default defineComponent({
    name: "Sirit Modal",
    props: {
        size: { type: String, required: false, default: 'md' },
        hideBackground: { type: Boolean, required: false, default: false }
    },
    setup () {
        return {
            //Routing
        }
    }
})
</script>

<style lang="scss">
    .sirit-modal-content {
        max-height: 95%;
        max-width: 95%;
        animation: fade;
        animation-duration: 0.3s;
        animation-iteration-count: 1;
    }
</style>
